(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('HospitalizationType', HospitalizationType);

    HospitalizationType.$inject = ['$resource'];

    function HospitalizationType ($resource) {
        var resourceUrl =  'api/hospitalization-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
